import { combineReducers } from "redux";
import { oprState } from "./oprReducer";

export const oprReducers = combineReducers({
    oprState: oprState
});
